import { render, staticRenderFns } from "./UserAuthorityList.vue?vue&type=template&id=02895168&"
import script from "./UserAuthorityList.vue?vue&type=script&lang=js&"
export * from "./UserAuthorityList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports